<mc-select-list [dataListId]="dataListId" listClass="mc-list-selectable" [listControl]="listControl">
  <ng-template mcListItem let-project>
    <mat-list-item>
      <mc-project-avatar [disabled]="true" [project]="project" size="small" [truncate]="true"></mc-project-avatar>
    </mat-list-item>
  </ng-template>

  <ng-template mcEmptyList>
    <p>No projects found.</p>
  </ng-template>

  <ng-template mcAllItemsLoadedList>
    <p>All projects loaded.</p>
  </ng-template>
</mc-select-list>
